<button
  class="buttonLinkDs__cont buttonLinkDs__cont--icon-{{iconPosition}} buttonLinkDs__cont--{{type}}"
  aria-label="buttonLinkDs"
  [class.disabled]="isDisabled"
  (click)="clickEvent.emit()">
  <div class="icon">
    <app-ds-icon
      [icon]="icon"
      [size]="iconSize">
    </app-ds-icon>
  </div>
  <div class="label">
    <app-ds-typography
      [size]="fontSize"
      [fontFamily]="fontFamily"
      [text]="label">
    </app-ds-typography>
  </div>
</button>